export const FONT = Object.freeze({
  나눔명조: "'Nanum Myeongjo', serif",
  '나눔손글씨 손편지체': "'Nanum Pen Script', cursive",
  Pretendard: "'Pretendard', sans-serif",
  'Noto Sans': "'Noto Sans KR', sans-serif",
});
